(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductCategoryProductDeleteController',ProductCategoryProductDeleteController);

    ProductCategoryProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProductCategoryProduct'];

    function ProductCategoryProductDeleteController($uibModalInstance, entity, ProductCategoryProduct) {
        var vm = this;
        vm.productCategoryProduct = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ProductCategoryProduct.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
